module.exports = __webpack_public_path__ + "edd8f75a8aadee455222b0549df69174.svg";